<template>
    <v-dialog
    v-model="localDialog"
    width="35%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
    >
        <v-card>
            <v-card-title class="text-h6">
                <span class="text-center">Progress Template Update</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-form @submit.prevent="submit" ref="ProjectTemplateUpdateSetup">
                    <v-row>
                        <v-col cols="12">
                            <v-text-field
                                label="Project Code"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                class="px-2"
                                v-model="code.value.value"
                                :error-messages="code.errorMessage.value"
                                readonly=""
                                clearable
                            ></v-text-field>

                            <v-select
                                :items="getProgressTemplateList"
                                :item-title="(item) => `${item.name} - ${item.code}`"
                                item-value="id"
                                label="Project Template"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="progress_template_id.value.value"
                                :error-messages="progress_template_id.errorMessage.value"
                                clearable
                            >
                                <template #label>
                                Project Template <span class="text-red-accent-4">*</span>
                                </template>
                            </v-select>

                            <v-textarea
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="description.value.value"
                                :error-messages="description.errorMessage.value"
                                clearable
                            >
                                <template #label>
                                Remarks <span class="text-red-accent-4">*</span>
                                </template>
                            </v-textarea>

                            <v-date-input
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                label="Date"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="date.value.value"
                                :error-messages="date.errorMessage.value"
                                autocomplete="off"
                                clearable
                            >
                                <template #label>
                                Date
                                <span class="text-red-accent-4">*</span>
                                </template>
                            </v-date-input>

                            <!-- <v-checkbox
                                label="Active"
                                v-model="status.value.value"
                                :error-messages="status.errorMessage.value"
                                density="compact"
                                variant="outlined"
                                hide-details
                                single-line
                                color="primary"
                                value="1"
                            ></v-checkbox> -->
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn
                                class="bg-red"
                                variant="flat"
                                type="reset"
                                @click="closeDialog"
                                >Close</v-btn
                            >
                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { ref, watch } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { useRoute } from "vue-router";
import formattedDate from '@/plugins/dateFormatter';
import { baseURL } from "@/store/api";

export default {
    name: "ProjectTemplateUpdateSetup",
    props: {
        dialog: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Object,
            default: () => ({
                project_id: "",
                status: "1",
                code: "",
                description: "",
            }),
        },
    },
    data() {
        return {
            localDialog: this.dialog,
            selectedImage: null,
            errorMessages: "",
            loading: false,
            isEntryMode: true,
        };
    },
    watch: {
        dialog(val) {
            this.localDialog = val;
        },
        localDialog(val) {
            this.$emit("update:dialog", val);
        },
        data: {
            handler(newData) {
                this.isEntryMode = !newData.project_id;
                this.resetForm({ errors: {}, touched: {} });
                // this.status.setValue(String(newData.status) || "1", false);
                this.status.setValue("1", false);
                this.project_id.setValue(newData.project_id || "", false);
                this.code.setValue(newData.code || "", false);
                this.description.setValue(newData.description || "", false);
            },
        },
    },
    created() {
        if (this.$store.getters.getProgressTemplateList.length == 0) {
            this.$store.dispatch("getProgressTemplateList");
        }
    },
    computed: {
        getProgressTemplateList() {
            return this.$store.getters.getProgressTemplateList;
        }
    },
    methods: {
        updateDialog(val) {
            this.$emit("update:dialog", val);
        },
        closeDialog() {
            this.$emit("update:dialog", false);
        },
    },
    setup(props, { emit }) {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                project_id: yup.string().required().label("Project"),
                progress_template_id: yup.string().required().label("Progress Template"),
                date: yup.string().nullable().label("Date"),
                description: yup.string().nullable().label("Description"),
                status: yup.string().required().label("Status"),
            }),
        });
        const project_id = useField("project_id");
        const progress_template_id = useField("progress_template_id");
        const code = useField("code");
        const date = useField("date");
        const description = useField("description");
        const status = useField("status", undefined, { initialValue: "1" });
        const errorMessages = ref("");
        const loading = ref("");
        const store = useStore();
        const route = useRoute();

        const submit = handleSubmit((values) => {
            values.date = formattedDate(
                date.value.value
            );
            // const formData = new FormData();
            // Object.keys(values).forEach((key) => { formData.append(key, values[key] || "");});
            const id = route.params.id;
            store.dispatch("saveUpdateProjectAssignTemplate", {
                id: id,
                data: values
                })
                .then((response) => {
                    resetForm();
                    emit("update:dialog", false);
                    toast.success(response.data.message);
                    loading.value = true;
                    axios.get(baseURL + "project/progress-summary", id).then((data) => {
                        loading.value = false;
                    })
                    // .catch((error) => {
                    //     loading.value = false;
                    //     toast.error(error.response.data.message);
                    // });
                })
                .catch((error) => {
                    toast.error(error.response.data.message);
                });
        });
        return {
            submit,
            project_id,
            progress_template_id,
            code,
            date,
            description,
            errorMessages,
            resetForm,
            status,
            loading,
        };
    },
    mounted() {
        this.date.value.value = new Date();
    },
};
</script>
